import { useState } from "react";

import axios from "axios";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

export function PasswordDialog({ open, onOpenChange, sessionId, API }) {
  const [targetUser, setTargetUser] = useState("user");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (newPassword !== confirmPassword) {
      
      return;
    }
    if (newPassword.length < 4) {
      
      return;
    }

    try {
      setSaving(true);
      await axios.put(`${API}/admin/password?session_id=${sessionId}`, {
        target_username: targetUser,
        new_password: newPassword,
      });
      
      setNewPassword("");
      setConfirmPassword("");
      onOpenChange(false);
    } catch (err) {
      
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle 
            className="text-xl font-bold uppercase tracking-tight"
          >
            Passwort ändern
          </DialogTitle>
          <DialogDescription>
            Ändern Sie das Passwort für einen Benutzer.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 pt-4">
          <div className="space-y-2">
            <Label className="uppercase tracking-[0.15em] text-xs font-semibold">
              Benutzer
            </Label>
            <Select value={targetUser} onValueChange={setTargetUser}>
              <SelectTrigger data-testid="password-user-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="user">user</SelectItem>
                <SelectItem value="admin">admin</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label className="uppercase tracking-[0.15em] text-xs font-semibold">
              Neues Passwort
            </Label>
            <Input
              data-testid="new-password-input"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Neues Passwort"
              className="input-focus"
            />
          </div>

          <div className="space-y-2">
            <Label className="uppercase tracking-[0.15em] text-xs font-semibold">
              Passwort bestätigen
            </Label>
            <Input
              data-testid="confirm-password-input"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Passwort bestätigen"
              className="input-focus"
            />
          </div>

          <Button
            data-testid="save-password-button"
            onClick={handleSave}
            disabled={saving || !newPassword || !confirmPassword}
            className="w-full"
          >
            {saving ? "Wird gespeichert..." : "Passwort speichern"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
